/**
 * Day-end cash close (medopd-docs 99): the day's collections by mode, the drawer count and the history of closes.
 */
import { fetchApi } from '../client';

export interface CashCloseRecord {
  id: string;
  businessDate: string;
  openingFloat: number;
  cashCollected: number;
  cashExpected: number;
  countedCash: number;
  difference: number;
  handedOver: number;
  floatCarried: number;
  totalsByMode: string | null;
  collectionsCount: number;
  denominations: string | null;
  notes: string | null;
  closedBy: string;
  closedByName: string | null;
  closedAt: string;
}

export interface CashCloseLine {
  id: string;
  collectedAt: string;
  billId: string;
  billNumber: string | null;
  amount: number;
  mode: string;
  reference: string | null;
  collectedBy: string | null;
  billVoided: boolean;
}

export interface CashCloseSummary {
  date: string;
  openingFloat: number;
  openingFrom: string | null;
  totalsByMode: Record<string, number>;
  countByMode: Record<string, number>;
  cashCollected: number;
  cashExpected: number;
  collectionsCount: number;
  collections: CashCloseLine[];
  byCollector: Array<{ name: string; cash: number; other: number; count: number }>;
  current: CashCloseRecord | null;
  closesCount: number;
  cashAfterClose: number;
  countAfterClose: number;
}

export interface CashCloseRequest {
  date: string;
  countedCash: number | null;
  handedOver: number;
  notes?: string;
  denominations?: Record<string, number>;
}

export const cashCloseModule = {
  /** No date = the clinic's today (the server's business date). */
  summary: (date?: string) =>
    fetchApi<CashCloseSummary>(`/api/cash-close/summary${date ? `?date=${encodeURIComponent(date)}` : ''}`),
  close: (body: CashCloseRequest) =>
    fetchApi<CashCloseRecord>('/api/cash-close', { method: 'POST', body: JSON.stringify(body) }),
  /** No range = the last 30 days up to the clinic's today. */
  history: (from?: string, to?: string) =>
    fetchApi<CashCloseRecord[]>(`/api/cash-close/history${from && to ? `?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}` : ''}`),
};
